import { Avatar, Checkbox, Group, Text, UnstyledButton } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import React from 'react';
import { GET_PLANS } from '../../services/payments';

export interface PlanFormProps{

}
export interface PlanFormHandle{
    getData: () => { planId: number };
}
const PlanForm : React.ForwardRefRenderFunction<
    PlanFormHandle,
    PlanFormProps
> = ({}, ref) => {
    const [plans, setPlans] = React.useState<any[]>([]);
    const [planId, setPlanId] = React.useState<number>(null);

    React.useImperativeHandle(ref, () => ({
        getData: () => ({
            planId
        })
    }))

    React.useEffect(() => {
        GET_PLANS()
        .then((plans) => {
            setPlans(plans)
        })
        .catch(err => {
            showNotification({title: "Ops.", message: err.message, color: 'red'})
        })
    }, [])

    return <div>
        {plans.map(plan => <UnstyledButton onClick={() => setPlanId(plan.id)}>
            <Group>
                <Checkbox checked={planId === plan.id} />
                <div>
                    <Text>{plan.title}</Text>
                    {/* <Text size="xs" color="dimmed">Clique para emitir o relatório</Text> */}
                </div>
            </Group>
        </UnstyledButton>)}
    </div>
}

export default React.forwardRef(PlanForm);
